module.exports = __webpack_public_path__ + "static/media/kool11.e58ac375.png";